export default "__VITE_ASSET__BacOzR1$__"